import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
const restylaneProducts = ['Restylane Refyne', 'Restylane Defyne', 'Restylane Lyft', 'Restylane Contour', 'Restylane Kysse', 'Restylane Silk'];
const juvedermProducts = ['Juvederm Ultra', 'Juvederm Ultra Plus', 'Juvederm Vollure', 'Juvederm Volbella', 'Juvederm Voluma'];
export function DFWhatAre() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-933">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-934">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-935">
          {/* Left Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-936">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-937">
              WHAT ARE DERMAL FILLERS?
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-938"></div>

            <div className="space-y-6 text-[#B0B0B0] text-base leading-[1.8] font-body mb-10" data-id="element-939">
              <p data-id="element-940">
                Dermal fillers are injectable substances designed to add volume,
                smooth lines and restore contours to the face. They are commonly
                used for facial rejuvenation and can address areas like
                nasolabial folds, cheeks, lips and under-eye hollows.
              </p>
              <p data-id="element-941">
                They work by adding volume to the treated areas, typically with
                ingredients like hyaluronic acid. This helps plump up the skin,
                reduce the appearance of wrinkles, and restore a more youthful
                and refreshed look.
              </p>
            </div>

            {/* Brand Cards - Always Open */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch" data-id="element-942">
              {/* Restylane Card */}
              <div className="bg-white p-8 lg:p-10 shadow-[0_4px_16px_rgba(0,0,0,0.08)] border-t-[3px] border-[#FF1493] flex flex-col" data-id="element-943">
                <h3 className="text-xl lg:text-2xl font-bold font-[Poppins,_sans-serif] text-black mb-5" data-id="element-944">
                  <span className="text-[#FF1493]" data-id="element-945">Restylane</span> Fillers
                </h3>

                <p className="text-[#333333] text-[15px] leading-[1.7] font-body mb-5" data-id="element-946">
                  Restylane fillers are a popular choice for individuals looking
                  to restore volume, smooth wrinkles, and enhance facial
                  contours. These fillers are made from hyaluronic acid, a
                  substance naturally found in the body, making them
                  biocompatible and safe for use. Restylane fillers are known
                  for their safety, effectiveness and versatility, offering
                  patients customizable treatment options to achieve their
                  desired aesthetic goals. At Be CLINICAL, we love Restylane
                  fillers because they provide natural-looking results that last
                  for several months to a year, depending on the specific
                  formulation and individual factors.
                </p>
                <ul className="space-y-2 mt-auto" data-id="element-947">
                  {restylaneProducts.map(product => <li key={product} className="flex items-center gap-3 text-[14px] text-[#333333] font-body" data-id="element-948">
                      <span className="w-2 h-2 rounded-full bg-[#FF1493] flex-shrink-0" data-id="element-949"></span>
                      {product}
                    </li>)}
                </ul>
              </div>

              {/* Juvederm Card */}
              <div className="bg-white p-8 lg:p-10 shadow-[0_4px_16px_rgba(0,0,0,0.08)] border-t-[3px] border-[#FF1493] flex flex-col" data-id="element-950">
                <h3 className="text-xl lg:text-2xl font-bold font-[Poppins,_sans-serif] text-black mb-5" data-id="element-951">
                  <span className="text-[#FF1493]" data-id="element-952">Juvederm</span> Fillers
                </h3>

                <p className="text-[#333333] text-[15px] leading-[1.7] font-body mb-5" data-id="element-953">
                  Juvederm is a well-established and widely recognized brand in
                  the field of dermal fillers. Known for its comprehensive range
                  of products, Juvederm utilizes hyaluronic acid-based
                  formulations to target specific aesthetic goals. Juvederm
                  fillers are often categorized into different product lines,
                  each tailored to address particular concerns like fine lines,
                  volume loss, or lip enhancement.
                </p>
                <ul className="space-y-2 mt-auto" data-id="element-954">
                  {juvedermProducts.map(product => <li key={product} className="flex items-center gap-3 text-[14px] text-[#333333] font-body" data-id="element-955">
                      <span className="w-2 h-2 rounded-full bg-[#FF1493] flex-shrink-0" data-id="element-956"></span>
                      {product}
                    </li>)}
                </ul>
              </div>
            </div>
          </AnimateOnScroll>

          {/* Right Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-957">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-958">
              <img src="https://cdn.magicpatterns.com/uploads/k96LK2hzScz67FrZkSKwRR/AdobeStock_269743252-1.webp" alt="Dermal Filler Injection Close-Up" className="w-full h-full object-cover" data-id="element-959" />
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}